import React from 'react'
import styled from 'styled-components'
import Responsive from '../../assets/config/Responsive'
import CloseIcon from '../../assets/icons/JSX/CloseIcon'
import Colors from '../../assets/styles/Colors'
import { Scrollbar } from '../../assets/styles/GlobalStyle'
import Button from '../Button'
import { useTranslation } from 'react-i18next'
import InfoIcon from '../../assets/icons/JSX/InfoIcon'
import { currencySymbol, georgianFormatter } from '../../domain/types'

const PendingPayModal: React.FC<{
  isOpen: boolean
  onClose: Function
  children: React.ReactNode
  orderModalInfo?: any
  orderInfo?: any
  onClick?: () => void
}> = ({ isOpen = false, onClose, children, orderModalInfo, orderInfo, onClick }) => {
  //
  const { t } = useTranslation()
  const formatAmount = (value: unknown) => {
    const numericValue = Number(value)
    return georgianFormatter.format(Number.isFinite(numericValue) ? numericValue : 0)
  }
  //
  //
  return isOpen === false ? null : (
    <>
      <Wrapper>
        <MobileHeader>
          <HeaderText>
            <div>
              <span>{t('paymentDetails')}</span>
            </div>
          </HeaderText>
          <HeaderText>
            <div>
              <CloseModalBtnMobile onClick={() => onClose()}>
                <CloseIcon />
              </CloseModalBtnMobile>
            </div>
          </HeaderText>
        </MobileHeader>

        <Scrollbar hideScroll={isOpen} />
        <ShadowBackground onClick={() => onClose()} />
        <Content>
          <CloseModalBtnStyle onClick={() => onClose()}>
            <CloseIcon />
          </CloseModalBtnStyle>
          <PaymentInfo>
            <Title>{t('paymentDetails')}</Title>
            <ContentStyles>
              {orderModalInfo?.map((item: any, index: number) => (
                <Info key={index}>
                  <div>
                    <Text>
                      <span>
                        <div> {t('insuranceCompany')}</div>
                      </span>
                    </Text>
                    <Text>
                      <span>
                        <InsuranceText>
                          {item?.companyName} /{item?.insuranceType}
                        </InsuranceText>
                      </span>
                    </Text>
                  </div>
                  {item?.paymentScheduleType === 'MONTHLY' || item?.paymentScheduleType === 'MONTHLY-FIRST-TWO' ? (
                    <>
                      <div>
                        <Text>
                          <span>
                            <div>{t('totalAmount')}</div>
                          </span>
                        </Text>
                        <Text>
                          <span>
                            <div>
                              {formatAmount(item?.totalPrice)} {currencySymbol(item?.currency || 'GEL')}
                            </div>
                          </span>
                        </Text>
                      </div>
                      <div>
                        <Text>
                          <span>
                            <div>{t('eachPayment')}</div>
                          </span>
                        </Text>
                        <Text>
                          <span>
                            <div>
                              {formatAmount(item?.monthlyPrice)} {currencySymbol(item?.currency || 'GEL')}
                            </div>
                          </span>
                        </Text>
                      </div>
                      <div>
                        <Text>
                          <span>
                            <div>{t('firstPayment')}</div>
                          </span>
                        </Text>
                        <Text>
                          <span>
                            <div>
                              {formatAmount(item?.eachPrice)} {currencySymbol(item?.currency || 'GEL')}
                            </div>
                          </span>
                        </Text>
                      </div>
                    </>
                  ) : (
                    <div>
                      <Text>
                        <span>
                          <div>{t('amountTotal')}</div>
                        </span>
                      </Text>
                      <Text>
                        <span>
                          <div>
                            {formatAmount(item?.amount)} {currencySymbol(item?.currency || 'GEL')}
                          </div>
                        </span>
                      </Text>
                    </div>
                  )}
                </Info>
              ))}
              <Amount>
                <AmountText>{t('currentPayment')}</AmountText>
                <AmountText>
                  {orderInfo?.currentPaymentAmount || orderInfo?.currentPaymentAmount === 0
                    ? formatAmount(orderInfo?.currentPaymentAmount)
                    : formatAmount(orderInfo?.totalPrice)}{' '}
                  {currencySymbol('GEL')}
                </AmountText>
              </Amount>

              {orderInfo?.discountUsed && !orderInfo?.validPromoCode ? (
                <InfoBox>
                  <InfoIconStyle /> <InfoText>{t('cantPayWithPromoCode')}</InfoText>
                </InfoBox>
              ) : null}

              <InfoBox>
                <InfoIconStyle /> <InfoText>{t('thePriceIsDetermined')}</InfoText>
              </InfoBox>

              <Button onClick={onClick} text={t('goToCheckout')} fullWidth />
            </ContentStyles>
          </PaymentInfo>
          {/* <div>{children}</div> */}
        </Content>
      </Wrapper>
    </>
  )
}

//
const InfoIconStyle = styled(InfoIcon)`
  width: 18px !important;
  height: 18px !important;
`
const MobileHeader = styled.div`
  display: none;
  position: sticky;
  top: 0;
  left: 0;
  width: 100%;
  height: 64px;
  background-color: ${Colors.white};
  align-items: center;
  user-select: none;
  z-index: 2;
  -webkit-box-shadow: 0px 0px 15px 3px #88888811;
  box-shadow: 0px 0px 15px 3px #88888811;
  padding-left: 100px;
  padding-right: 100px;
  ${Responsive.mobile} {
    display: flex;
    justify-content: space-between;
    padding-left: 25px;
    padding-right: 25px;
    z-index: 101;
    /* height: 64px; */
  }
`
const ContentStyles = styled.div`
  display: flex;
  flex-direction: column;
  padding: 30px;
  padding-bottom: 50px;
  margin-bottom: 20px;
  /* border-bottom: 1px solid ${Colors.secondaryGrey}; */
  div {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  button {
    margin-top: 35px;
  }
  span:not(:last-of-type) {
    border-bottom: 2px solid ${Colors.secondaryGrey};
  }
  /*  */
  &:last-child {
    border: 0px;
    margin-bottom: 0px;
    padding-bottom: 10px;
  }
  ${Responsive.mobile} {
    display: flex;
    flex-direction: column;
    padding: 10px;
    padding-bottom: 30px;
    /* margin-bottom: 20px; */
    border-bottom: 1px solid ${Colors.secondaryGrey};
    div {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    /*  */
    &:last-child {
      border: 0px;
      margin-bottom: 0px;
      padding-bottom: 10px;
    }
  }
`
const Text = styled.div`
  font-size: 15px;
  color: ${Colors.primaryGrey};
  user-select: none;
  margin-bottom: 5px;
  /* responsive */
  ${Responsive.mobile} {
    font-size: 16px;
    margin-left: 0;
    padding-left: 0;
  }
`
const HeaderText = styled.div`
  ${Responsive.mobile} {
    color: ${Colors.primaryBlack};
    user-select: none;
    margin-bottom: 5px;
    font-size: 16px;
    margin-left: 0;
    padding-left: 0;
  }
`
const CloseModalBtn = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: auto;
  border: 0px;
  background-color: transparent;
  outline: none;
  padding: 10px;
  margin-right: -10px;
  margin-top: -10px;
  svg {
    width: 14px;
    height: 14px;
    color: ${Colors.rollingStone};
  }
  /*  */
  &:hover {
    svg {
      color: ${Colors.primaryBlack};
    }
  }
`
const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  z-index: 101;
  ${Responsive.mobile} {
    background-color: ${Colors.grey};
    display: block;
    overflow-y: scroll;
  }
`
const ShadowBackground = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 5;
  background-color: black;
  opacity: 0.3;
  width: 100%;
  height: 100vh;
  ${Responsive.mobile} {
    display: none;
  }
`
const Content = styled.div`
  padding: 24px;
  background-color: white;
  z-index: 6;
  border-radius: 8px;
  position: relative;
  min-width: 550px;
  max-width: 550px;
  min-height: 20vh;
  max-height: 100vh;
  overflow-y: scroll;
  padding-bottom: 50px;
  overflow: hidden;
  /*  */
  ${Responsive.mobile} {
    padding: 25px 10px 50px;
    min-width: unset;
    margin: 40px 25px;
    border-radius: 8px;
    padding-bottom: 40px;
    max-width: unset;
  }
`
const Amount = styled.div`
  background-color: ${Colors.lightGrey};
  border-radius: 5px;
  padding: 18px 20px;
  margin-top: 30px;
  ${Responsive.mobile} {
    margin-top: 20px;
    padding: 5px 25px 15px;
  }
`
const AmountText = styled.div`
  font-size: 15px;
  color: ${Colors.primaryBlack};
  user-select: none;
  /* responsive */
  ${Responsive.mobile} {
    margin-left: 0;
    padding-left: 0;
    margin-top: 10px;
  }
`
const Title = styled.div`
  display: flex;
  text-align: center;
  justify-content: center;
  color: ${Colors.primaryBlack};
  font-size: 26px;
  ${Responsive.mobile} {
    font-size: 16px;
    text-align: left;
    justify-content: flex-start;
    padding-left: 10px;
  }
`
const CloseModalBtnStyle = styled(CloseModalBtn)`
  ${Responsive.mobile} {
    display: none;
  }
`
const CloseModalBtnMobile = styled(CloseModalBtn)`
  margin-top: 1px;
`
const PaymentInfo = styled.div``
const InsuranceText = styled.div`
  text-align: right;
`
const Info = styled.span`
  padding-top: 10px;
  padding-bottom: 10px;
`
const InfoBox = styled.div`
  display: flex;
  align-items: center;
  margin-block: 15px;
  max-width: 464px;
  margin-bottom: 0;
  margin-right: auto;

  svg {
    height: 24px;
    width: 24px;
    color: ${Colors.primaryRed};
  }
`
const InfoText = styled.p`
  margin-top: 5px;
  margin-bottom: 0px;
  margin-left: 10px;
  font-size: 12px;
  color: ${Colors.primaryGrey};
`

export default PendingPayModal
